<template>
    <div class="page" v-if="rdv">
        <h1>Confirmez votre rendez-vous</h1>
    
        <section class="section-display">
            <div class="section-header" :class="{ success: rdvConfirmation === true, danger: rdvConfirmation === false }">
                <h2>{{ rdv.json_data.Typedaction }}</h2>
                <span class="status" v-if="rdvConfirmation !== null"><i class="material-icons">circle</i>{{ rdvConfirmation ? 'Confirmé' : 'Annulé' }}</span>

            </div>
    
            <div class="section-body">
                <article>
                    <div>
                        <span class="label">{{ formatDate(rdv.json_data.Dateheuredébutaction) }}</span>
                        <div class="icon-paragraph">
                            <i class="material-icons">access_time</i>
                            <p class="time">{{ formatTime(rdv.json_data.Dateheuredébutaction) }}</p>
                            <span class="label">{{ formatMinutes(rdv.json_data.Durée) }}</span>
                        </div>
                    </div>
                </article>
    
                <article>
                    <div>
                        <div class="icon-paragraph">
                            <i class="material-icons">person_outline</i>
                            <div>
                                <p>{{ rdv.json_data.IntervenantBGE }}</p>
                                <span class="label">Votre conseiller</span>
                            </div>
                        </div>
                    </div>
                </article>
                
                <article>
                    <div>
                        <div class="icon-paragraph">
                            <i class="material-icons">location_on</i>
                            <div>
                                <p v-if="rdv.json_data.Modedintervention === 'Présentiel'">{{ rdv.json_data.Lieudaction }}</p>
                                <span class="label">{{ rdv.json_data.Modedintervention === 'Présentiel' ? rdv.json_data.address : rdv.json_data.Modedintervention }}</span>
                                <Sub_DescriptionLabel 
                                    v-if="rdv.json_data.description"
                                    :text="rdv.json_data.description"
                                ></Sub_DescriptionLabel>
                            </div>
                        </div>
                    </div>
                </article>
    
                <article v-if="rdv.json_data.Modedintervention === 'Présentiel' && rdv.json_data.iframe_url">
                    <iframe 
                        :src="rdv.json_data.iframe_url" 
                        width="100%" 
                        height="250" 
                        style="border:0; padding: 0; margin: 0;" 
                        allowfullscreen="" 
                        loading="lazy" 
                        referrerpolicy="no-referrer-when-downgrade"></iframe>
                </article>
            </div>
        </section>

        <aside class="contact-info">
            <p>Pour toute demande, contactez le secrétariat au&nbsp;<a href="tel:+33145805155">01&nbsp;45&nbsp;80&nbsp;51&nbsp;55</a></p>
        </aside>
    
        <aside class="footer">
            <div class="grouped-btn" v-if="rdvConfirmation === null">
                <button class="secondary-button-outlined btn" @click="showModal = true">Non</button>
                <button class="primary-button btn" @click="confirmRDV(true)"><i class="material-icons">check</i>&nbsp;Oui, je confirme</button>
            </div>

            <!-- <div class="single-btn" v-else>
                <button class="primary-button btn" v-if="rdvConfirmation === true">Ajouter à mon agenda</button>
                <button class="primary-button btn" v-else>Reproposer un créneau</button>
            </div>   -->
        </aside>
    </div>

    <Sub_MobileModal v-model="showModal">
        <div class="mobile-modal">
            <h2>Pourquoi annulez-vous&nbsp;?</h2>
            <p>Cette information aide votre conseiller à vous reproposer un créneau adapté.</p>
    
            <div class="form">
                <label for="unavailable-today">
                    <input type="radio" v-model="cancel_reason" value="Indisponible ce jour-là" id="unavailable-today">
                    <span>Indisponible ce jour-là</span>
                </label>
    
                <label for="health-issue">
                    <input type="radio" v-model="cancel_reason" value="Problème de santé" id="health-issue">
                    <span>Problème de santé</span>
                </label>
    
                <label for="professional-obligation">
                    <input type="radio" v-model="cancel_reason" value="Obligation professionnelle" id="professional-obligation">
                    <span>Obligation professionnelle</span>
                </label>
    
                <label for="transport-issue">
                    <input type="radio" v-model="cancel_reason" value="Problème de transport" id="transport-issue">
                    <span>Problème de transport</span>
                </label>
    
                <label for="family-reason">
                    <input type="radio" v-model="cancel_reason" value="Raison familiale" id="family-reason">
                    <span>Raison familiale</span>
                </label>
    
                <label for="other">
                    <input type="radio" v-model="cancel_reason" value="Autre" id="other">
                    <span>Autre</span>
                </label>

                <textarea id="description" v-model="cancel_description" rows="4" placeholder="Précisions (optionnel)"></textarea>
    
                <div class="grouped-btn">
                    <button class="secondary-button-outlined btn" @click="showModal = false">Retour</button>
                    <button class="danger-button btn" @click="confirmRDV(false, true)" :disabled="!cancel_reason">Annuler le RDV</button>
                </div>
            </div>
        </div>
    </Sub_MobileModal>

    <Sub_MobileModal v-model="promptQuestionModal">
        <div class="mobile-modal">
            <h2>Êtes-vous déjà immatriculé(e)&nbsp;?</h2>
            <p>Disposez-vous déjà d'un numéro SIRET, même sans activité à ce jour&nbsp;?</p>
    
            <div class="form">
                <label for="immatricule">
                    <input type="radio" v-model="immatricule" value="oui" id="immatricule">
                    <span>Oui, je suis immatriculé(e).</span>
                </label>

                <label for="non_immatricule">
                    <input type="radio" v-model="immatricule" value="non" id="non_immatricule">
                    <span>Non, je ne suis pas encore immatriculé(e).</span>
                </label>
    
                <div class="grouped-btn">
                    <button class="secondary-button-outlined btn" @click="promptQuestionModal = false">Retour</button>
                    <button class="primary-button btn" @click="confirmRDV(true, true)" :disabled="!immatricule">Confirmer le RDV</button>
                </div>
            </div>
        </div>
    </Sub_MobileModal>
</template>

<script setup>
    import apiClient                    from '@/api';
    import { onMounted, ref, watch }    from 'vue';
    import { useRoute, useRouter }      from 'vue-router'
    import Sub_MobileModal              from './Sub_MobileModal.vue';
    import Sub_DescriptionLabel         from './Sub_DescriptionLabel.vue';

    const route     = useRoute()
    const router    = useRouter() 

    const rdv               = ref(null)
    const rdvConfirmation   = ref(null)
    const showModal         = ref(null)

    // Question pour les Diagnostic (indiv) afin de savoir s'ils sont déjà immatriculés ou non.
    const promptQuestionModal   = ref(false)
    const immatricule           = ref('non')

    const cancel_reason         = ref(null)
    const cancel_description    = ref(null)

    function decodeHtmlEntities(text) {
        const txt = document.createElement("textarea")
        txt.innerHTML = text
        return txt.value
    }

    const fetchRDV = async (url) => {
        try {
            const response = await apiClient.get('/check_for_rdv/', { params: {
                url: url
            }})
            rdv.value               = response.data.data
            rdvConfirmation.value   = rdv.value.confirmation

            await fetchLocations(rdv.value.json_data.Lieudaction, rdv.value.date)

        } catch (e) {
            router.push('/404')
        }
    }

    const fetchLocations = async (lieu, date) => {
        try {
            const response = await apiClient.get('/get_location/', { params: {
                location_name : lieu,
                today: date
            } })

            rdv.value.json_data.address     = response.data.data.address
            rdv.value.json_data.iframe_url  = decodeHtmlEntities(response.data.data.iframe_url)
            rdv.value.json_data.description = response.data.data.description
        } catch (e) {
            console.log(e)
        }
    }

    const confirmRDV = async (response_boolean, bypassQuestion = false) => {
        if (rdv.value.json_data.Typedaction === 'Diagnostic (indiv)' && bypassQuestion === false) {
            promptQuestionModal.value = true

            return
        }

        try {
            const payload = {
                confirmation:   response_boolean,
                rdv:            route.query.ref
            }

            if (response_boolean === false) {
                payload.cancel_reason       = cancel_reason.value
                payload.cancel_description  = cancel_description.value
            }

            if (rdv.value.json_data.Typedaction === 'Diagnostic (indiv)') {
                payload.immatricule = immatricule.value
            }

            console.log(payload)

            await apiClient.post('/confirm_rdv/', payload)
            
            await fetchRDV(route.query.ref)
            showModal.value             = false 
            promptQuestionModal.value   = false
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch (e) {
            console.error(e)
        }
    }

    function formatTime(timeStr) {
        const [hh, mm] = timeStr.split(" ")[1].split(":")
        return String(parseInt(hh, 10)).padStart(2, '0') + ':' + mm
    }

    function formatDate(dateStr) {
        const [ day, month, year, hour, min ] = dateStr.match(/\d+/g)

        const date = new Date(year, month - 1, day, hour, min)

        return date.toLocaleDateString('fr-FR', {
            weekday: 'long',
            day: 'numeric',
            month: 'long'
        }).replace(/^./, c => c.toUpperCase())
    }

    function formatMinutes(minutes) {
        if (isNaN(minutes)) return

        if (minutes < 60) {
            return `${minutes} min`
        }

        const hours = Math.floor(minutes / 60)
        const mins  = minutes % 60
        
        return mins === 0 ? `${hours} h` : `${hours} h ${mins}`
    }

    watch(showModal, (value) => {

        if (value === false) {
            cancel_reason.value         = null
            cancel_description.value    = null
        }
    })

    watch(promptQuestionModal, (value) => {
        if (value === false) {
            immatricule.value = 'non'
        }
    })

    onMounted(() => {
        const url = route.query.ref
        fetchRDV(url)
    })
</script>

<style lang="scss" scoped>
html label, body label {
    display: inline;
}

h1 {
    margin: 1rem 2rem;

    font-size: 1.6rem;
}

.section-display {
    background-color: $white;

    margin-inline: auto;
    // margin-bottom: 15vh;
    
    width: 85vw;
    
    -webkit-border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 25px;
    border-radius: 25px;

    overflow: hidden;

    .section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        background-color: rgba($base-blue, .25);
        color: $base-blue;

        padding: 1rem 1.5rem;
        
        h2 {
            margin: 0;
            
            font-size: .8rem;
            text-transform: uppercase;
        }

        span.status {
            display: flex;
            align-items: center;
            gap: 6px;

            font-size: .8rem;
            text-transform: uppercase;

            color: $white;

            padding: 2px 12px;

            border-radius: 25px;

            i {
                font-size: .5rem;
            }
        }

        &.success {
            background-color: rgba($dark-green, .15);
            color: $dark-green;

            span.status {
                background-color: $dark-green;
            }
        }

        &.danger {
            background-color: rgba($darkred, .15);
            color: $darkred;

            span.status {
                background-color: $darkred;
            }
        }
    }

    .section-body {
        background-color: $white;

        p {
            margin: 0;
        }

        .icon-paragraph {
            display: flex;

            align-items: center;
            gap: 1rem;

            i {
                color: $base-blue;
                font-size: 2rem;
            }

            p {
                font-weight: bold;
                white-space: pre-line;
            }

            .time {
                font-size: 2rem;
            }

        }

        span.label {
            color: $dark-gray;
        }

        p.description-label,
        .description-label {
            color: $dark-gray;
            font-weight: normal;

            margin-top: .5em;

            white-space: pre-line;
        }
        
        article > div {
            padding: .5rem 1rem;
        }

        iframe {
            display: block;
        }

        article:not(:last-child) {
            border-bottom: solid 1px $gray;
        }
    }
}

.grouped-btn {
    display: flex;
    justify-content: center;
    gap: 1rem;

    margin: 1rem 0;
}

.single-btn {
    display: flex;
    justify-content: center;
    margin-inline: 2rem;
    margin-bottom: 1rem;

    .btn {
        width: 100%;
        display: flex;
        justify-content: center;
    }
}

.btn {
    padding: .8rem 2rem;
    border-radius: 25rem;
    
    display: flex;
    align-items: center;

    &:hover {
        box-shadow: $drop-shadow 2px 2px 6px;
    }
}

.page {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
}

.footer {
    margin-top: auto;
}

.mobile-modal {
    h2 {
        font-size: clamp(1rem, 4dvw, 1.4rem);
        margin-bottom: 0.5dvh;
    }

    p, span {
        font-size: clamp(0.8rem, 3.5dvw, 1rem);
    }
}

.form {
    display: flex;
    flex-direction: column;
    gap: clamp(0.5rem, 1.5dvh, 1rem);
    margin-top: clamp(0.75rem, 2dvh, 1.25rem);

    label, textarea {
        background-color: transparent;
        border: 2px solid $gray;
        border-radius: 15px;
        padding: clamp(0.6rem, 1.5dvh, 1rem) clamp(0.75rem, 2dvw, 1rem);

        display: flex;
        gap: 1rem;

        font-size: clamp(0.8rem, 3.5dvw, 1rem);

        &:hover {
            cursor: pointer;
        }

        input[type="radio"] {
            appearance: none;
            -webkit-appearance: none;

            width: clamp(16px, 3dvw, 20px);
            height: clamp(16px, 3dvw, 20px);
            flex-shrink: 0;

            border: 2px solid $gray;
            border-radius: 40%;
            background: white;
            display: inline-block;
            position: relative;
        }

        input[type="radio"]:checked {
            border-color: $base-blue;
        }

        input[type="radio"]:checked::after {
            content: "";
            width: clamp(8px, 1.5dvw, 10px);
            height: clamp(8px, 1.5dvw, 10px);
            background: $base-blue;
            border-radius: 40%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    textarea {
        resize: none;
        outline: none;
        font-family: inherit;
        line-height: 1.5;
        min-height: clamp(80px, 15dvh, 120px);
        cursor: text;

        &::placeholder {
            color: $gray;
            font-size: clamp(0.75rem, 3dvw, 0.9rem);
        }
    }
}

.grouped-btn {
    display: flex;
    gap: clamp(0.5rem, 2dvw, 1rem);
    margin-top: clamp(0.5rem, 1.5dvh, 1rem);

    .btn {
        padding: clamp(0.5rem, 1.5dvh, 0.75rem) clamp(1.5rem, 2dvw, 1rem);
        font-size: clamp(0.8rem, 3dvw, 1rem);
        border-radius: 25px;
        white-space: nowrap;
    }
}

@media (max-height: 500px) {
    .form {
        gap: 0.4rem;

        label, textarea {
            padding: 0.5rem 0.75rem;
        }
    }

    .grouped-btn {
        margin-top: 0.4rem;
    }
}

button:disabled {
    background-color: $gray;
    border-color: transparent;
    pointer-events: none;
}

.contact-info {
    display: flex;
    justify-content: center;

    p {
        text-align: center;
        width: 80vw;
        margin-top: 1rem;

        font-style: italic;
        font-size: .9rem;
    }
}
</style>